<template>
  <div class="page">
    <div v-if="isLoading" class="loading">
      <div class="progress-icon full-screen"></div>
    </div>
    <div v-else>
      <div class="home-main-wrap" ref="pageWrap">
        <div class="right-section" :style="{ width: sectionWidth.right + '%' }">
          <!-- Don't Remove This Otherwise Drag And Drop will not Work -->
          <div class="app-overlay" v-show="isDragging"></div>

          <navbar-top
            :customUserNavItems="customDatabases"
            :activeDatabase="activeDatabase"
            :isRefreshingOnNavbar="isRefreshingOnNavbar"
            :isLeftNavbarVisible="toggleNav"
            @toggleNewDataType="toggleNewDataType"
            @toggleShareDatabase="toggleShareDatabase"
            @toggleRemoveDatabase="toggleRemoveDatabase"
            @toggleLeaveDatabase="toggleLeaveDatabase"
            @toggleEditDatabaseSchema="toggleEditDatabaseSchema"
            @toggleLeftNavbar="toggleLeftNavbar"
            v-show="section != 'process-designer'"
          />

          <div class="main-content px-45">
            <div
              :class="{
                'load-profile-list':
                  db.type == 'loadprofile' && section == 'data',
                'custom-database-list':
                  section == 'data' && db.type != 'loadprofile',
              }"
              v-for="db in customDatabases"
              :key="db.name"
            >
              <LoadProfileList
                v-if="
                  db.type == 'loadprofile' &&
                  section == 'data' &&
                  db.name == activeDatabase.name
                "
                :key="db.name"
                :database="db"
                :activeDatabase="activeDatabase.name"
                :itemID="itemID"
                :isNewDataTypeModalVisible="isNewDataTypeModalVisible"
              />
              <CustomList
                v-else-if="section == 'data' && db.name == activeDatabase.name"
                :key="db.name"
                :database="db"
                :activeDatabase="activeDatabase.name"
                :itemID="itemID"
                :isNewDataTypeModalVisible="isNewDataTypeModalVisible"
              />
            </div>
            <ProcessList v-show="section == 'flows'" />
            <ProcessDesigner
              v-if="section == 'process-designer'"
              :databases="customDatabases"
              :processID="processID"
            />
            <NoDatabases v-if="noDatabases && section == 'data'" />
          </div>
        </div>
        <navbar-left
          :customUserNavItems="customDatabases"
          :activeDatabase="activeDatabase"
          :isLeftNavbarVisible="toggleNav"
          :style="{ width: sectionWidth.left + '%' }"
          :leftNavbarWidth="leftNavbarWidth"
          @toggleNewDataType="toggleNewDataType"
          @toggleShareDatabase="toggleShareDatabase"
          @toggleRemoveDatabase="toggleRemoveDatabase"
          @toggleLeaveDatabase="toggleLeaveDatabase"
          @toggleEditDatabaseSchema="toggleEditDatabaseSchema"
          @toggleLeftNavbar="toggleLeftNavbar"
          @toggleCopyDatabase="closeNewDataType"
          @changeDataBaseOrder="changeDataBaseOrder"
          @getCustomDatabases="getCustomDatabases"
          @updateNavWidth="updateNavWidth"
          v-show="section != 'flows' && section != 'process-designer'"
        />
      </div>
      <tableShareModal
        v-if="isShareTableModalVisible"
        :database="activeDatabase"
        @close="toggleShareDatabase"
      />
      <NewDataType
        v-if="isNewDataTypeModalVisible"
        class="modal-window"
        :tableList="customDatabasesNames"
        :editTable="editTable"
        :databaseMeta="activeDatabase"
        @close="closeNewDataType"
      />
      <removeConfirmationModal
        v-if="confirmationModal.isVisible"
        class="modal-window"
        :id="confirmationModal.id"
        :name="confirmationModal.name"
        :resourceType="confirmationModal.resourceType"
        :actionType="confirmationModal.actionType"
        @close="toggleConfirmationModal"
        @confirmRemove="removeDatabase"
        @confirmLeave="leaveDatabase"
      />
    </div>
  </div>
</template>

<script>
import NavbarTop from './NavbarTop.vue';
import NavbarLeft from './NavbarLeft.vue';
import CustomList from './CustomList.vue';
import LoadProfileList from './LoadProfileList.vue';
import NoDatabases from './NoDatabases.vue';
import ProcessList from './ProcessList.vue';
import NewDataType from '../components/NewDataType.vue';
import ProcessDesigner from '../components/Process.vue';
import tableShareModal from './modals/tableShareModal.vue';
import removeConfirmationModal from './modals/removeConfirmModal.vue';
import store from '../store/store';
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  data() {
    return {
      isComponentLoading: true,
      isNewDataTypeModalVisible: false,
      isShareTableModalVisible: false,
      confirmationModal: {
        id: null,
        name: null,
        actionType: null,
        isVisible: false,
        resourceType: 'database',
      },
      editTable: false,
      customDatabases: [],
      leftNavbarWidth: 420,
      toggleNav: true,
      isRefreshingOnNavbar: false,
    };
  },
  props: {
    section: String,
    database: String,
    processID: String,
    itemID: String,
  },
  methods: {
    toggleLeftNavbar(toggleLeftNav) {
      this.toggleNav = toggleLeftNav;
    },
    updateNavWidth(event) {
      this.leftNavbarWidth = event;
    },
    getFrontendTableNameFormat(name) {
      return name.slice(name.indexOf('_') + 1);
    },

    async getCustomDatabases() {
      try {
        this.isRefreshingOnNavbar = true;
        await this.$store.dispatch('fetchUserDataBase');

        this.isRefreshingOnNavbar = false;
        this.databaseList;
        for (let e of this.databaseList) {
          if (!e.hasOwnProperty('layout'))
            e.layout =
              '{"tabs":[{"id":0,"rows":[{"id":0,"cols":[{"id":0}]}]}]}';
          if (!e.hasOwnProperty('iconType')) e.linkType = 'icon';
          this.customDatabases = this.databaseList;
          // Push to db if no query params
          if (!this.section || (this.section == 'data' && !this.database)) {
            let db;
            if (this.userSettings && this.userSettings.selectedDatabase)
              db = this.userSettings.selectedDatabase;
            else if (
              this.userSettings &&
              !this.userSettings.selectedDatabase &&
              this.databaseList.length > 0
            )
              db = this.databaseList[0].name;
            else db = 'noDatabases';
            this.$router.push({
              path: '/',
              query: { section: 'data', database: db },
            });
          }
        }
        this.isComponentLoading = false;
      } catch (error) {
        this.isComponentLoading = false;
        this.isRefreshingOnNavbar = false;
      }
    },
    toggleShareDatabase: function () {
      this.isShareTableModalVisible = !this.isShareTableModalVisible;
    },
    toggleRemoveDatabase: function (id) {
      this.$set(this.confirmationModal, 'id', id);
      this.$set(this.confirmationModal, 'name', this.nameWithoutPrefix(id));
      this.$set(this.confirmationModal, 'actionType', 'remove');
      this.toggleConfirmationModal();
    },
    toggleLeaveDatabase: function (id) {
      this.$set(this.confirmationModal, 'id', id);
      this.$set(this.confirmationModal, 'name', this.nameWithoutPrefix(id));
      this.$set(this.confirmationModal, 'actionType', 'leave');
      this.toggleConfirmationModal();
    },
    toggleEditDatabaseSchema: function () {
      this.editTable = true;
      this.toggleNewDataType();
    },
    toggleConfirmationModal: function () {
      this.$set(
        this.confirmationModal,
        'isVisible',
        (this.confirmationModal.isVisible = !this.confirmationModal.isVisible)
      );
    },
    removeDatabase: function (name) {
      var url = process.env.VUE_APP_DATA_API;
      url += '/user-tables/' + name;

      // API headers
      var myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      return fetch(url, {
        headers: myHeaders,
        method: 'DELETE',
      })
        .then((response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 404)
            throw new Error('Resource not found');
          else if (response.status == 401) {
            localStorage.clear();
            this.$router.push({
              name: 'auth',
              params: { message: 'Sitzung abgelaufen' },
            });
          } else throw new Error('CORS');
        })
        .then((item) => {
          if (item.ResponseMetadata.HTTPStatusCode === 200) {
            this.customDatabases = this.customDatabases.filter(
              (e) => e.name !== name
            );
          }
          this.$store.commit('SET_DATABASE_LIST', this.customDatabases);
          let database;

          // Change to another DB
          if (this.customDatabases.length > 0)
            database = this.customDatabases[0].name;
          else database = 'noDatabases';
          this.$router.push({
            path: '/',
            query: { section: 'data', database: database },
          });
        })
        .catch(() => {});
    },
    leaveDatabase: function (name) {
      var policyId = this.customDatabases.find((e) => e.name == name)[
        'policy_id'
      ];

      var url = process.env.VUE_APP_DATA_API;
      url += '/user-tables/' + name + '/share';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('Content-Type', 'application/json');

      let payload = {
        policy_id: policyId,
      };

      fetch(url, {
        headers: myHeaders,
        body: JSON.stringify(payload),
        method: 'DELETE',
      })
        .then((response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 404)
            throw new Error('Resource not found');
          else if (response.status == 401) {
            localStorage.clear();
            this.$router.push({
              name: 'auth',
              params: { message: 'Sitzung abgelaufen' },
            });
          } else throw new Error('CORS');
        })
        .then(() => {
          this.customDatabases = this.customDatabases.filter(
            (e) => e.name != name
          );
          let database;

          // Change to another DB
          if (this.customDatabases.length > 0)
            database = this.customDatabases[0].name;
          else database = 'noDatabases';
          this.$router.push({
            path: '/',
            query: { section: 'data', database: database },
          });
        })
        .catch(() => {});
    },
    toggleNewDataType: function () {
      document.body.classList.add('modal-open');
      this.isNewDataTypeModalVisible = !this.isNewDataTypeModalVisible;
    },
    closeNewDataType: function () {
      document.body.classList.remove('modal-open');
      this.isNewDataTypeModalVisible = false;
      this.editTable = false;
      this.getCustomDatabases();
    },
    nameWithoutPrefix: function (name) {
      return name.split('_').slice(1).join('_');
    },
    changeDataBaseOrder(dragIdx, dropIdx) {
      const dragEl = this.customDatabases.splice(dragIdx, 1)[0];
      this.customDatabases.splice(dropIdx, 0, dragEl);
    },
  },
  created() {
    this.getCustomDatabases();
    if (this.userSettings) {
      this.leftNavbarWidth =
        typeof this.userSettings.leftNavbarWidth === 'number' &&
        this.userSettings.leftNavbarWidth < 420 &&
        this.userSettings.leftNavbarWidth > 210
          ? this.userSettings.leftNavbarWidth
          : 420;
      this.toggleNav = this.userSettings.isShowLeftNavbar;
    }
  },

  computed: {
    ...mapGetters({
      databaseList: 'getDatabaseList',
      isDragging: 'getDatabaseDragging',
    }),
    user() {
      return store.state.user;
    },
    customDatabasesNames() {
      return this.customDatabases.map((e) => e.name);
    },
    noDatabases() {
      return this.customDatabases.length < 1 && !this.isFlowListVisible;
    },
    activeDatabase() {
      let db = this.database;
      let dbs = this.customDatabases;
      let filteredDbs = dbs.filter((e) => e.name == db);

      if (filteredDbs.length == 1) return filteredDbs[0];
      else {
        if (dbs.length > 0) return dbs[0];
        else return { name: 'noDatabases' };
      }
    },
    shiftToRight() {
      let sections = ['flows', 'process-designer'];
      if (this.toggleNav === false) {
        return '';
      } else {
        return !sections.includes(this.section);
      }
    },
    isLoading() {
      return this.$store.state.isLoading || this.isComponentLoading;
    },
    userSettings() {
      return store.state.userSettings;
    },
    screenWidth() {
      return window.screen.width;
    },
    sectionWidth() {
      if (this.toggleNav !== false) {
        const pc = this.screenWidth / 100;
        const width = (this.screenWidth - this.leftNavbarWidth) / pc;
        return {
          left: 100 - width,
          right: width,
          screen: this.screenWidth,
          pc: pc,
          width: width,
        };
      } else {
        return {
          left: 0,
          right: 100,
        };
      }
    },
  },
  components: {
    NavbarTop,
    NavbarLeft,
    CustomList,
    LoadProfileList,
    NoDatabases,
    ProcessDesigner,
    NewDataType,
    tableShareModal,
    removeConfirmationModal,
    ProcessList,
  },
};
</script>

<style>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.main-content {
  height: calc(100vh - 120px);
  position: relative;
}
.main-content,
.main-content * {
  box-sizing: border-box;
}
.sign-out {
  width: 160px;
  margin: 0 auto;
}

.page {
  height: 100%;
  background-color: #f9f9fb;
  width: 100%;
  overflow: hidden;
}

.round-button::selection {
  background: transparent;
}

.loading {
  height: 100%;
  background-color: #f9f9fb;
}

.progress-icon.full-screen {
  position: fixed;
  left: 50%;
  transform: translate(-50%);
  top: 50%;
  width: 70px;
  height: 70px;
}

.progress-icon.full-screen:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.right-section {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  transition: all 200ms ease-in-out;
}

.collapse {
  width: 0 !important;
}

/*Updated Loader*/
.loading {
  height: 100%;
  background-color: #f9f9fb;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
}

.progress-icon.full-screen {
  position: absolute;
  left: 0;
  -webkit-transform: translate(-50%);
  transform: translateY(-50%);
  top: 50%;
  width: 100%;
  height: 70px;
  margin: 0 auto;
}

.progress-icon.full-screen:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  box-sizing: border-box;
  margin: 0 auto;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

.home-main-wrap {
  display: flex;
  flex-direction: row-reverse;
  min-height: 100vh;
  width: 100%;
}

.app-overlay {
  height: 100%;
  width: 100%;
  z-index: 99;
  position: absolute;
  display: block;
}
</style>
